<template lang="pug">
  div
    HeaderForTopPage(:client_no="client_no", :firm_name="firm_name")
    HeaderMenu(:neo_contract_status="neo_contract_status", :chat_contract_status="chat_contract_status", :isLoadingHeader="isLoadingHeader", :sales_channel="sales_channel", :has_special_priced_item="has_special_priced_item", :display_e_invoice_flg="display_e_invoice_flg")
    router-view.mx-auto.body-width.pb-2(:sales_channel="sales_channel", :has_special_priced_item="has_special_priced_item")
</template>

<script>
import Api from '@/repositories/api'
const HeaderInfoRepository = Api.get('c205HeaderInfo')

import HeaderForTopPage from "@/components/supportSite/HeaderForTopPage";
import HeaderMenu from "@/components/supportSite/HeaderMenu";

export default {
  /* eslint-disable */
  name: "Index",
  components: {
    HeaderForTopPage,
    HeaderMenu
  },
  data() {
    return {
      // お客様番号
      client_no: '- -',
      // 会社名
      firm_name: '- -',
      // 販売種別
      sales_channel: '',
      // 優待価格商品保有フラグ
      has_special_priced_item: '',
      // 電子請求システムの表示フラグ
      display_e_invoice_flg: false,
      // NEOの契約情報ステータス
      neo_contract_status: null,
      // ChatLuckの契約情報ステータス
      chat_contract_status: null,
      // ローディングのステータス
      isLoadingHeader: false
    }
  },
  methods: {
    setHeader() {
      // システムエラー画面の場合は何もしない
      if (this.$route.name.includes('SystemError') === false) {
        // 読み込み中
        this.isLoadingHeader = true;
        // ヘッダー情報を初期化する
        this.client_no = '- -'
        this.firm_name = '- -'

        // 画面表示前共通処理を実行する
        HeaderInfoRepository.get()
          .then((response) => {
            // NEO
            this.neo_contract_status = response.data.common.neo.contract === true ? response.data.common.neo.contract_status : false

            // chat
            this.chat_contract_status = response.data.common.chat.contract === true ? response.data.common.chat.contract_status : false

            // 顧客番号を取得
            this.client_no = response.data.common.client.client_no
            // 会社名を取得
            this.firm_name = response.data.common.client.firm_name
            // 販売種別を取得
            this.sales_channel = response.data.common.client.sales_channel
            // 優待価格商品保有フラグを取得
            this.has_special_priced_item = response.data.common.client.has_special_priced_item
            // 電子請求システムの表示フラグを取得
            this.display_e_invoice_flg = response.data.common.client.is_e_invoice

            // ローカルストレージに顧客番号を保存する
            localStorage.setItem('client_no', this.client_no)

            // NEOがサービス中でない場合
            if (response.data.common.neo.contract_status !== '4') {
              // ローカルストレージからキー削除
              localStorage.removeItem('neo_domain_name')
            }
            // chatがサービス中でない場合
            if (response.data.common.chat.contract_status !== '4') {
              // ローカルストレージからキー削除
              localStorage.removeItem('chat_domain_name')
            }

            // 各画面にアクセスできないはずのユーザがURL直打ちでアクセスした場合、トップページに強制遷移する
            let iAlert = 0
            // エラーメッセージの番号を設定する
            // chatが環境構築中の場合は、NEOの契約申込画面へ遷移したにトップページへ遷移する
            if ((this.$route.name === 'ContractNeoOrder' || this.$route.name === 'ContractNeoConfirm') && this.chat_contract_status === '3') {
              iAlert = 4
            }
            // NEOが環境構築中の場合は、chatの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractChatOrder' || this.$route.name === 'ContractChatConfirm') && this.neo_contract_status === '3') {
              iAlert = 5
            }
            // NEOが契約中の場合は、NEOの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractNeoOrder' || this.$route.name === 'ContractNeoConfirm') && (this.neo_contract_status === '3' || this.neo_contract_status === '4' || this.neo_contract_status === '5')) {
              iAlert = 6
            }
            // chatが契約中の場合は、chatの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractChatOrder' || this.$route.name === 'ContractChatConfirm') && (this.chat_contract_status === '3' || this.chat_contract_status === '4' || this.chat_contract_status === '5')) {
              iAlert = 7
            }

            // エラーがある場合はトップページに遷移する
            if (iAlert !== 0) {
              this.$router.push({name: "TopPage", query: {'alert': iAlert}})
            }
          })
          .catch((error) => {
            // 未ログインの場合を除くエラーの場合はシステムエラーとする
            if (error.response.status !== 401) {
              this.$router.push({
                name: "SupportSystemError",
                params: {
                  error_msg: '画面表示処理'
                }
              })
            }
            // セッションの期限が切れている場合はログイン画面に遷移する
            this.moveToLoginPage()
          })
          .finally(() => [
            // 読み込み完了
            this.isLoadingHeader = false
          ])
      }
    }
  },
  created() {
    // 最初に画面表示前共通処理を実行する
    this.setHeader()
  },
  watch: {
    // 画面遷移の度に画面表示前共通処理を実行する
    $route: function () {
      this.setHeader()
    }
  },
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
  /*max-width: 1123px;*/
}
</style>
